import { QueryKey } from '@/configs/queryKeys';
import { User } from '@/types/user';
import { UUID } from '@/types/types';
import { Currency } from './CompanyApi';
import { InvestmentItem } from './InvestmentItemApi';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export enum InvestmentStatus {
	NOT_SENT = 'NOT_SENT',
	SENT = 'SENT',
	CANCELLED = 'CANCELLED',
	IN_PROGRESS = 'IN_PROGRESS',
	COMPLETED = 'COMPLETED',
}

export interface ShippingInvestmentData {
	shippingName: string;
	shippingStreet: string;
	shippingCity: string;
	shippingPostalCode: string;
	shippingPhoneNumber: string;
}

export interface InvestmentDelivery extends BaseEntity {
	name: string;
	deliverDate: Date;
	investment: Investment;
}

export interface SubmitInvestmentDeliveryLine {
	configurationArticleCode: string;
	quantity: number;
}

export interface SubmitInvestmentDelivery {
	name: string;
	deliverDate: string;
	deliveryLines: SubmitInvestmentDeliveryLine[];
}

export interface Investment extends BaseEntity, ShippingInvestmentData {
	number: string;
	name: string;
	user: User;
	currency: Currency;
	investmentDate: Date;
	address: string;
	description: string;
	status: InvestmentStatus;
	isArchived: boolean;
	investmentItems: InvestmentItem[];
	investmentDeliveries: InvestmentDelivery[];
}

class InvestmentApi extends EntityApi<Investment> {
	constructor() {
		super(QueryKey.investments);
		this.cancelInvestment = this.cancelInvestment.bind(this);
		this.submit = this.submit.bind(this);
	}

	async cancelInvestment(investmentId: UUID) {
		const response = await httpClient.patch<Investment>(
			`${this.queryKey}/${investmentId}/cancel`,
			{}
		);

		return response.data;
	}

	async submit(payload: {
		id: UUID;
		shippingData: ShippingInvestmentData;
		investmentDeliveries: SubmitInvestmentDelivery[];
	}) {
		const response = await httpClient.patch<Investment>(
			`${this.queryKey}/${payload.id}/submit`,
			{
				...payload.shippingData,
				investmentDeliveries: payload.investmentDeliveries,
			}
		);

		return response.data;
	}
}

export default new InvestmentApi();
